import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  makeStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import ConsentCore from 'src/components/ConsentCore';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  dialogTitleRoot: {
    paddingRight: theme.spacing(6) // sağda X butonu için boşluk
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(0.75),
  }
}));

const ConsentViewPopup = ({ open, setOpen, ConsumerId }) => {
  const { t } = useTranslation('overview');
  const classes = useStyles();

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle disableTypography className={classes.dialogTitleRoot}>
        {/* Başlık gerekiyorsa buraya ekleyebilirsin */}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <ConsentCore
          ConsumerId={ConsumerId}
          onClose={handleClose}
        />
      </DialogContent>

      <DialogActions>{/* Gerekirse butonlar */}</DialogActions>
    </Dialog>
  );
};

export default ConsentViewPopup;
